import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components/macro';
import { pageReverseLookup } from '../../content/commerce/itemLookup';
import { categories } from '../../content/commerce/itemCategories';
import { Heading3, Span } from '../../components/typography';

const Container = styled.div`
  margin-bottom: 20px;
`;
const HeadlineContainer = styled(Heading3)`
  border: 2px solid #D8D8DA;
  margin: 0px;
  padding: 15px;
  background: ${({ theme }) => theme.colors.colorBlueHighlight};
  background: -moz-linear-gradient(left, ${({ theme }) => theme.colors.colorBlueHighlight} 0%, ${({ theme }) => theme.colors.colorGreyLight} 100%);
  background: -webkit-linear-gradient(left, ${({ theme }) => theme.colors.colorBlueHighlight} 0%,${({ theme }) => theme.colors.colorGreyLight} 100%);
  background: linear-gradient(to right, ${({ theme }) => theme.colors.colorBlueHighlight} 0%,${({ theme }) => theme.colors.colorGreyLight} 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${({ theme }) => theme.colors.colorBlueHighlight}', endColorstr='${({ theme }) => theme.colors.colorGreyLight}',GradientType=1 );
  &:hover {
    cursor: pointer;
  }
`;

class SearchCategory extends React.Component {
  onGotoCategory = () => {
    const {
      history,
      category,
    } = this.props;
    const p = pageReverseLookup[category];
    const { name } = categories[category];
    if (p) {
      history.push(`/bestil${p}/kategori/${name}`);
    }
  }

  render() {
    const {
      category,
      children,
    } = this.props;
    const { headline, packaging } = categories[category];
    return (
      <Container>
        <HeadlineContainer onClick={this.onGotoCategory}>
          {headline && (<React.Fragment>{headline()}</React.Fragment>)}{packaging && (<React.Fragment> {packaging}</React.Fragment>)}
          <Span block fontSize="12px" paddingTop="5px">
            Tryk for at gå til kategori
          </Span>
        </HeadlineContainer>
        {children}
      </Container>
    );
  }
}

export default withRouter(SearchCategory);
